<template>
  <div
    v-if="fields"
    class="quiz-question-wrapper d-flex flex-column justify-center"
  >
    <div class="d-flex flex-column justify-center align-center text-center my-3">
      <span aria-hidden="true">
        <i
          v-if="siteConfig"
          class="quiz-icon mdi"
          :class="[
            'mdi-'+fields.icon,
            (siteConfig.navBottomBorderColor === 'orange') ? 'gold--text' : 'accent--text'
          ]"
        />
      </span>
      <v-col
        col="12"
        md="8"
        class="quiz-question"
      >
        <h2 class="quiz-question-header my-6" tabindex="-1" :id="'QuestionHeader' + index">
          {{ fields.question }}
        </h2>
      </v-col>
      <fieldset style="border: none;">
        <legend class="font-large dark-gray--text mb-6">
          Select one
        </legend>
        <base-button
          :text="fields.affirmativeText || 'Yes'"
          class="my-2 focus-ind"
          :class="{ 'selected': selected === 'y' }"
          :aria-current="(selected === 'y').toString()"
          style="max-width: 450px; width: 100%"
          color="primary"
          outline
          @click="setSelection('y')"
          @focus="buttonFocused(0)"
          @blur="buttonFocused(-1)"
        />
        <base-button
          :text="fields.negativeText || 'No'"
          class="my-2 focus-ind"
          :class="{ 'selected': selected === 'n' }"
          :aria-current="(selected === 'n').toString()"
          style="max-width: 450px; width: 100%"
          color="primary"
          outline
          @click="setSelection('n')"
          @focus="buttonFocused(1)"
          @blur="buttonFocused(-1)"
        />
        </fieldset>
      <div
        v-if="fields.affirmativeSelectedText || fields.negativeSelectedText"
        class="font-default-size dark-gray--text mt-6"
        style="max-width: 450px; min-height: 100px; width: 100%"
      >
        <div v-if="selected">
          {{ (selected === 'y') ? fields.affirmativeSelectedText : fields.negativeSelectedText }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters, mapMutations } from 'vuex'
import { QUIZ_TYPES } from '@/store/modules/quiz'

export default {
  name: 'QuizQuestion',
  props: {
    fields: {
      type: Object,
      default: null
    },
    index: {
      type: Number,
      default: 0
    }
  },
  data () {
    return {
      focusIndex: -1
    }
  },
  computed: {
    ...mapGetters({ selected: QUIZ_TYPES.getters.selected }),
    ...mapState({ siteConfig: state => state.site.siteConfig }),
    ...mapState('quiz', ['activeQuestion', 'selections'])
  },
  methods: {
    ...mapMutations({ setSelection: QUIZ_TYPES.mutations.SET_SELECTION }),
    focusHeader () {
      var id = '#QuestionHeader' + this.index
      setTimeout(function () {
        var header = document.querySelector(id)
        if (header) {
          header.focus()
        }
      }, 0)
    },
    buttonFocused (i) {
      this.focusIndex = i
      console.log(this.focusIndex)
    }
  },
  watch: {
    index: {
      handler: 'focusHeader',
      immediate: true
    }
  }
}
</script>

<style lang="scss" scoped>
  @import 'src/styles/variables';
  .quiz-icon {
    font-size: 75px;
  }
  .quiz-question {
    max-height: 200px; //if this seems arbitrary and hastily done, it is.
  }
  .base-button.outline.selected {
    color: $white !important;
    background-color: $primary !important;
  }
  .quiz-question-header {
    &:focus, &:active {
      outline: none;
    }
  }
</style>
